import { useConfigDeductionSlaConfigs } from "@src/presentation/providers/config/ConfigDeductionSlaConfigsDataProvider";
import { ConfigListFooter } from "./ConfigListFooter";

export const ConfigDeductionSlaConfigsFooter = () => {
  const { total, page, limit, loading, setPage } = useConfigDeductionSlaConfigs();

  return (
    <ConfigListFooter
      total={total}
      page={page}
      limit={limit}
      loading={loading}
      onPageChange={setPage}
      ariaLabel="SLA Config Pagination"
    />
  );
};
